import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const NAV_ITEMS = [
  { path: '/', label: 'Dashboard', icon: '🏠' },
  { path: '/write', label: 'Write Article', icon: '✍️' },
  { path: '/import', label: 'Import URLs', icon: '📥' },
  { path: '/admin-preview', label: 'Layout Editor', icon: '📰' },
];

export default function Sidebar() {
  const { logout, user } = useAuth();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem('sidebarCollapsed') === 'true';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem('sidebarCollapsed', String(collapsed));
    } catch {}
  }, [collapsed]);

  return (
    <aside className={`sidebar${collapsed ? ' sidebar-collapsed' : ''}`}>
      {/* Brand + Toggle */}
      <div className="sidebar-header">
        {!collapsed && (
          <span className="sidebar-brand-text">Daily News CMS</span>
        )}
        <button
          className="sidebar-toggle"
          onClick={() => setCollapsed((c) => !c)}
          title={collapsed ? 'Expand menu' : 'Collapse menu'}
          aria-label={collapsed ? 'Expand menu' : 'Collapse menu'}
        >
          {collapsed ? '▶' : '◀'}
        </button>
      </div>

      {/* Navigation */}
      <nav className="sidebar-nav">
        {NAV_ITEMS.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`sidebar-nav-item${isActive ? ' sidebar-nav-active' : ''}`}
              title={collapsed ? item.label : undefined}
            >
              <span className="sidebar-nav-icon">{item.icon}</span>
              {!collapsed && (
                <span className="sidebar-nav-label">{item.label}</span>
              )}
            </Link>
          );
        })}
      </nav>

      {/* Footer: public site link + user + logout */}
      <div className="sidebar-footer">
        <a
          href="http://localhost:8000"
          target="_blank"
          rel="noopener noreferrer"
          className="sidebar-nav-item"
          title={collapsed ? 'Public Site' : undefined}
        >
          <span className="sidebar-nav-icon">📺</span>
          {!collapsed && <span className="sidebar-nav-label">Public Site ↗</span>}
        </a>

        <div className={`sidebar-user${collapsed ? ' sidebar-user-collapsed' : ''}`}>
          <span className="sidebar-nav-icon">👤</span>
          {!collapsed && (
            <span className="sidebar-username">{user?.username}</span>
          )}
        </div>

        <button
          className="sidebar-nav-item sidebar-logout"
          onClick={logout}
          title={collapsed ? 'Logout' : undefined}
        >
          <span className="sidebar-nav-icon">🚪</span>
          {!collapsed && <span className="sidebar-nav-label">Logout</span>}
        </button>
      </div>
    </aside>
  );
}
